import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const gameConceptFields = [
  "gaming_gameconceptid", // UID
  "ggp_ggpprogram", // Choice - ProgramType
  "ggp_approvalstatus", // Choice - OpportunityApprovalStatus
  "gaming_approvalsubstatus", // Choice - OpportunityApprovalSubStatus
  "ggp_approvalstatuscomments", // Text
  "ggp_gameinformationformreceived", // Date
  "ggp_conceptapproved", // Date
  "gaming_SubmittedbyContactid", // Lookup - Contact
  "gaming_parentaccountid", // Lookup - Account
  "gaming_PublisherContactid", // Lookup - Contact
  "gaming_HubLastUpdateByContactId", // Lookup - Contact
  "gaming_ContractRequestId", // Lookup - Contract Request
  "ggp_submissiondocversion", // Text
  "gaming_gametitle", // Text
  "ggp_bigid", // Text
  "ggp_codename", // Text
  "ggp_genre", // Choice - Genre
  "ggp_additionalgenreinfo_ml", // Text
  "ggp_naesrb", // Choice - EsrbRating
  "ggp_gamedetails_ml", // Text
  "ggp_gameplaysummary", // Text
  "ggp_additionalinfo", // Text
  "ggp_freetoplay", // Choice - YesNo
  "ggp_retailprice", // Money
  "ggp_8ksupport", // Choice - YesNo
  "ggp_hdr", // Choice - YesNo
  "ggp_crossgenerationalcontent", // Choice - YesNo
  "ggp_cloudaware", // Choice - YesNo
  "ggp_raytracing", // Choice - YesNo
  "ggp_hfr", // Choice - YesNo
  "ggp_directstorage", // Choice - YesNo
  "ggp_theprojectscarlettdifference", // Text
  "ggp_singlemultiplayer", // Choice - YesNo
  "ggp_localmultiplayermode", // Choice - YesNo
  "ggp_localplayers", // Choice - LocalNumberOfPlayers
  "ggp_coop", // Choice - YesNo
  "ggp_coopconplayers", // Choice - LocalNumberOfPlayers
  "ggp_onlinesingleplayer", // Choice - YesNo
  "ggp_onlinemultiplayer", // Choice - YesNo
  "ggp_onlineconplayers", // Choice - LocalNumberOfPlayers
  "ggp_xboxlivecoopplay", // Choice - YesNo
  "ggp_crossplaywinstore", // Choice - YesNo
  "ggp_crossplaywin32", // Choice - YesNo
  "ggp_crossplayps4", // Choice - YesNo
  "ggp_crossplaynintendoswitch", // Choice - YesNo
  "ggp_crossplayother", // Choice - YesNo
  "ggp_sharedachievements", // Choice - YesNo
  "ggp_xboxplayanywhere", // Choice - YesNo
  "gaming_handheldconceptquest", // Choice - HandheldOptimizationChoice
  "gaming_smartdeliveryxboxoneandxboxseriesx", // Choice - YesNo
  "ggp_crossownership", // Choice - YesNo
  "ggp_crosssave", // Choice - YesNo
  "ggp_crossprogression", // Choice - YesNo
  "ggp_dlcpacks", // Choice - YesNo
  "ggp_durables", // Choice - YesNo
  "gaming_consumables", // Choice - YesNo
  "gaming_ingamesubscriptions", // Choice - YesNo
  "ggp_freeaddoncontent", // Choice - YesNo
  "ggp_addoncontentplandetails_ml", // Text
  "ggp_usergeneratedcontent", // Choice - YesNo
  "ggp_ugcdescription_ml", // Text
  "ggp_scarlett", // Choice - YesNo
  "ggp_xboxone", // Choice - YesNo
  "gaming_windowsstoreos", // Choice - YesNo
  "ggp_pc", // Choice - YesNo
  "ggp_nintendoswitch", // Choice - YesNo
  "gaming_nintendoswitch2", // Choice - YesNo
  "ggp_ps5", // Choice - YesNo
  "ggp_ps4hasreleasedate", // Choice - YesNo
  "ggp_android", // Choice - YesNo
  "ggp_ios", // Choice - YesNo
  "gaming_epicos", // Choice - YesNo
  "gaming_pcgog", // Choice - YesNo
  "ggp_otherplatform", // Choice - YesNo
  "ggp_otherplatformdesc", // Choice - YesNo
  "ggp_xgpxboxgamepreview", // Choice - YesNo
  "ggp_middlewarecurrentversion", // Text
  "ggp_middleware_ml", // Text
  "gaming_howfreegeneratesrevenue", // Text
  "gaming_retentionmechanics", // Text
  "gaming_ingamestore", // Choice - YesNo
  "gaming_ingamepricepointsandvc", // Text
  "gaming_ingamewhatcanbuy", // Text
  "gaming_timetillpromptedtopay", // Text
  "gaming_tradeorgiftallowed", // Choice - YesNo
  "gaming_howgiftedortraded", // Text
  "ggp_monthlysubscriptionrequired", // Choice - YesNo
  "gaming_descofsubmode", // Text
  "ggp_languages_ml", // Text
  "gaming_brazilianportuguese_langsup", // Choice - YesNo
  "gaming_english_langsup", // Choice - YesNo
  "gaming_french_langsup", // Choice - YesNo
  "gaming_german_langsup", // Choice - YesNo
  "gaming_italian_langsup", // Choice - YesNo
  "gaming_japanese_langsup", // Choice - YesNo
  "gaming_russian_langsup", // Choice - YesNo
  "gaming_polish_langsup", // Choice - YesNo
  "gaming_simplifiedchinese_langsup", // Choice - YesNo
  "gaming_spanish_langsup", // Choice - YesNo
  "gaming_traditionalchinese_langsup", // Choice - YesNo
  "gaming_korean_langsup", // Choice - YesNo
  "ggp_crossgenerationalcontentdetails", // Text
  "ggp_cloudawaredetails", // Text
  "ggp_8kdetails", // Text
  "ggp_directstoragedetails", // Text
  "ggp_hfrdetails", // Text
  "ggp_raytracingdetails", // Text
  "ggp_competingtitles", // Text
  "ggp_studioinformation", // Text
  "ggp_teammemberexperience", // Text
  "ggp_ugcdescription_ml", // Text
  "ggp_middlewareengine", // Choice
  "ggp_livecoopplayers", // Choice
  "ggp_nintendoswitchdate", // Date
  "gaming_nintendoswitch2date", // Date
  "ggp_ps5releasedate", // Date
  "ggp_ps4releasedate", // Date
  "ggp_androidreleasedate", // Date
  "ggp_iosrelease", // Date
  "ggp_otherplatformdesc", // Text
  "ggp_otherplatformrelease", // Date
  "ggp_scarlettreleasedate", // Date
  "ggp_xboxonelaunchdate", // Date
  "gaming_windowsstorereleasedate", // Date
  "ggp_pcreleasedate", // Date
  "gaming_epicreleasedate", // Date
  "gaming_gogreleasedate", // Date
  "ggp_tlareceived", // Date
  "gaming_GameConcept_Account_Developer", // Reference
  "ggp_additionaldevelopers_ml", // Text
  "gaming_contentvalidationstatus", // Text
  "gaming_steam", // Choice - YesNo
  "gaming_steamreleasedate", // Date
  "gaming_partneradditionallinks", // Text
  "ggp_gameinformationformreceived", // Date
  "gaming_onboardinghubcreated", // Boolean
  "gaming_visibletopartner", // Boolean
  "gaming_gamebuildlinks", // Text
  "gaming_gamebuildkeys", // Text
  "ggp_videotrailerlink_ml", // Text
  "gaming_roadmapnotes", // Text
  "ggp_retaildigitaldistribution", // Choice - YesNo
  "gaming_digitalonlyfreetoplay", // Choice - YesNo
  "ggp_xbladigitaldistribution", // Choice - YesNo
  "ggp_previouslypublished", // Choice - YesNo
  "gaming_previouslyreleaseddates", // Text
  "ggp_publishingresponsible", // Choice - YesNo
  "gaming_primarypublishername", // Text
  "ggp_certificationresponsible", // Choice - YesNo
  "gaming_partnerresponsibleforcertification", // Text
  "ggp_asiaprimarypublisher", // Text
  "ggp_asiasubpublisher", // Text
  "ggp_ausprimarypublisher", // Text
  "ggp_aussubpublisher", // Text
  "ggp_euprimarypublisher", // Text
  "ggp_eusubpublisher", // Text
  "ggp_japrimarypublisher", // Text
  "ggp_jasubpublisher", // Text
  "ggp_naprimarypublisher", // Text
  "ggp_nasubpublisher", // Text
  "ggp_saprimarypublisher", // Text
  "ggp_sasubpublisher", // Text
  "ggp_northamerica", // Date
  "ggp_europe", // Date
  "ggp_japanregion", // Date
  "ggp_asia", // Date
  "ggp_australian", // Date
  "ggp_southamerica", // Date
  "ggp_betaplanned", // Choice - YesNo
  "ggp_betadate", // Date
  "ggp_demoplanned", // Choice - YesNo
  "ggp_demodate", // Date
  "ggp_trialplanned", // Choice - YesNo
  "ggp_trialdate", // Date
  "ggp_germanyusk", // Choice - Germany USK Ratings
  "gaming_taiwancsrr", // Choice - Taiwan CSRR Ratings
  "ggp_europeisfepegi", // Choice - Europe ISFE/PEGI Ratings
  "ggp_australiaacb", // Choice - Australia ACB Ratings
  "gaming_russiapcbp", // Choice - Russia PCBP Ratings
  "ggp_japancero", // Choice - Japan CERO Ratings
  "ggp_koreagrb", // Choice - Korea GRB Ratings
  "ggp_saudiarabiagcam", // Choice - Saudi Arabia GCAM Ratings
  "ggp_brazil", // Choice - Brazil Ratings
  "gaming_newzelandoflc", // Choice - New Zealand OFLC Ratings
  "gaming_xboxseriesxperformancetargets", // Text
  "gaming_xboxseriessperformancetargets", // Text
  "ggp_internetrequired", // Choice - YesNo
  "ggp_internetrequireddetails", // Text
  "gaming_3dspatialsound", // Choice - YesNo
  "ggp_exclusivelyserverbasedgameplay", // Choice - YesNo
  "ggp_playersperserver", // Text
  "ggp_publisherhostedservices_ml", // Text
  "gaming_xboxlivesigninwindowsstore", // Choice - YesNo
  "gaming_xboxlivesigninps4", // Choice - YesNo
  "gaming_xboxlivesigninps5", // Choice - YesNo
  "gaming_xboxlivesigninswitch", // Choice - YesNo
  "gaming_xboxlivesigninepic", // Choice - YesNo
  "gaming_xboxlivesigninsteam", // Choice - YesNo
  "gaming_xboxlivesigninluna", // Choice - YesNo
  "gaming_xboxlivesigninandroid", // Choice - YesNo
  "gaming_xboxlivesigninios", // Choice - YesNo
  "gaming_xboxlivesigninother", // Choice - YesNo
  "gaming_xboxlivesigninother_name", // Choice - YesNo
  "gaming_xboxachievementswindowsstore", // Choice - YesNo
  "gaming_xboxachievementsps4", // Choice - YesNo
  "gaming_xboxachievementsps5", // Choice - YesNo
  "gaming_xboxachievementsswitch", // Choice - YesNo
  "gaming_xboxachievementsepic", // Choice - YesNo
  "gaming_xboxachievementssteam", // Choice - YesNo
  "gaming_xboxachievementsluna", // Choice - YesNo
  "gaming_xboxachievementsandroid", // Choice - YesNo
  "gaming_xboxachievementsios", // Choice - YesNo
  "gaming_xboxachievementsother", // Choice - YesNo
  "gaming_othernamexboxachievements", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithwindowsstore", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithps4", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithps5", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithswitch", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithepic", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithsteam", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithluna", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithandroid", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithios", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithother", // Choice - YesNo
  "gaming_xboxversionswillcrossplaywithother_name", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithwindo", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithps4", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithps5", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithswitc", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithepic", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithsteam", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithluna", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithandro", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithios", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithother", // Choice - YesNo
  "gaming_xboxversionwillcrosssaveprogresswithothna", // Choice - YesNo
  "gaming_winwillncrosssaveprogresswithxbox", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithps4", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithps5", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithswitch", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithepic", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithsteam", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithluna", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithandroid", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithios", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithother", // Choice - YesNo
  "gaming_winwillcrosssaveprogresswithothname", // Choice - YesNo
  "ggp_extraperipherals", // Choice - YesNo
  "ggp_peripheraldetails_ml", // Text
  "ggp_extraperipheralsrequired", // Choice - YesNo
  "ggp_extraperipheralsrequireddetails", // Text
  "ggp_targetreleasedate", // Date
  "gaming_xpapartnerconfirmedreleasedateutc", // Date
  "gaming_createdfor", // Picklist
  "gaming_hubsubmissiondate", // Date
  "gaming_hideshowinonboardinghub", // Picklist
  "gaming_gameplayduration", // Text
  "gaming_levelsdetails", // Text
  "gaming_levelsnumber", // Number
  "gaming_steamlink", // Text
  "gaming_itchiolink", // Text
  "gaming_sensitivecontent", // Choice - YesNo
  "gaming_sensitivecontentdetails", // Text
  "ggp_finalreleasedate",
] as const;

export const gameConceptReferences: EntityReferences<EntityName.gaming_gameconcept> = {
  [EntityName.account]: ["gaming_parentaccountid"],
  [EntityName.contact]: [
    "gaming_SubmittedbyContactid",
    "gaming_PublisherContactid",
    "gaming_HubLastUpdateByContactId",
  ],
  [EntityName.ggp_contractrequest]: ["gaming_ContractRequestId"],
};

export const gameConceptKey: AnyEntityField<EntityName.gaming_gameconcept> = "gaming_gameconceptid";
